/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_LoadingInputs */

const en_cc_loading = /** @type {(inputs: Cc_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

const id_cc_loading = /** @type {(inputs: Cc_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memeriksa…`)
};

/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Cc_LoadingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_loading = /** @type {((inputs?: Cc_LoadingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_LoadingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_loading(inputs)
	return en_cc_loading(inputs)
});